import axios from 'axios';
import store from '@/store';

const awsBackendAPI = 'https://aws.adhocstudio.ca/api';

const getLocalUser = () =>
  JSON.parse(localStorage.getItem(`blackline-${store.state.project.adhocId}-user`));

const removeLocalUser = () => {
  localStorage.removeItem(`blackline-${store.state.project.adhocId}-user`);
};

const setLocalUser = (user) => {
  localStorage.setItem(`blackline-${store.state.project.adhocId}-user`, JSON.stringify(user));
};

const checkLocalUser = async (token) => {
  if (token) {
    try {
      const res = await axios.get(`${awsBackendAPI}/allocations/agent`,
        { project_id: store.state.project.awsId },
        { header: { Authorization: token } }
      );
      if (res.status === 'ok') {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  return false;
};

const authenticate = async ({ email, password }) => {
  try {
    const res = await axios.post(`${awsBackendAPI}/agents/login`, {
      project_id: store.state.project.awsId,
      email,
      password
    });
    setLocalUser({
      agent: res.data.agent,
      token: res.data.token
    });
    return 'ok';
  } catch (error) {
    if (error.response) {
      return error.response.data.error;
    }
    return 'Could not login at this time. Please try again later.';
  }
};

export default {
  getLocalUser,
  removeLocalUser,
  setLocalUser,
  checkLocalUser,
  authenticate
};



// WEBPACK FOOTER //
// ./src/services/auth/index.js